<template>
    <b-modal v-model="showGekkoAccountantModal" :title="$gettext('Connect Gekko Accountant')" ok-only>
        <div>
            <div class="action-container">
                <span v-translate>Search by company name or user email:</span>
                
                <div class="input-container">
                    <b-form-input
                        v-model="searchText"
                        type="text"
                        :placeholder="$gettext('John Doe')"
                        style="margin-right: 5px" />
                    
                    <GekkoButton @click="searchCompanies()" :text="$gettext('Search')" style="margin-left: 5px" />
                </div>
            </div>
            <div v-if="!loading" class="company-list-container">
                <div v-for="company in companies" v-bind:key="company.id">
                    <button @click="connect(company)" class="company-button">
                        <div class="inside-button-element">
                            <div>Name:</div>
                            <div>{{company.name}}</div>
                        </div>
                        <div class="inside-button-element">
                            <div>Email:</div>
                            <div>{{company.email}}</div>
                        </div>
                        <div class="inside-button-element">
                            <div>KVK:</div>
                            <div>{{company.kvk}}</div>
                        </div>
                        <div class="inside-button-element">
                            <div>Address:</div>
                            <div>{{company.address}},&nbsp;{{company.city}},&nbsp;{{company.postal_code}}</div>
                        </div>
                    </button>
                </div>
            </div>
            <div v-if="!companies.length && !loading">
                <span style="font-style: italic" v-translate>No results</span>
            </div>
            <div v-if="loading">
                <b-spinner />
            </div>
        </div>
    </b-modal>
</template>
<script>
import { mapGetters } from 'vuex';

import GekkoButton from "@/components/GekkoButton";
import AccountantsService from "@/store/services/accountants.service";

export default {
    name: "GekkoAccountantModal",
    components: {GekkoButton},
    data() {
        return {
            showGekkoAccountantModal: false,
            companies: [],
            searchText: null,
            loading: false
        }
    },
    watch: {
        showGekkoAccountantModal(newVal) {
            if (!newVal)
                this.resetForm();
        }
    },
    computed: {
        ...mapGetters({ 
            getCompanyId: 'main/getCompanyId',
        }),
    },
    methods: {
        cancel() {
            this.close();
        },
        close() {
            this.resetForm();
            this.showGekkoAccountantModal = false;
        },
        resetForm() {
            this.searchText = null;
            this.companies = [];
        },
        searchCompanies() {
            this.loading = true;
            let params = {
                search: this.searchText
            }
            AccountantsService.searchCompanies(params).then((response) => {
                this.companies = response.data;
                this.loading = false;
            });
        },
        connect(company) {
            AccountantsService.createGekkoConnection(this.getCompanyId, company.id).then((response) => {
                this.$emit("connected", response.data);
                this.$store.commit("setAlert", {
                    title: this.$gettext("Success!"),
                    text: this.$gettext("Connected to ") + response.data.name + ".",
                    variant: "success",
                    duration: 4
                });
                this.close();
            }).catch((response) => {
                this.$store.commit("setAlert", {
                    title: this.$gettext("Error"),
                    text: response,
                    variant: "error",
                    duration: 4
                });
            });
        }
    }
}
</script>

<style scoped>
.company-list-container {
    max-height: 500px;
    overflow-y: auto;
}

.input-container {
    display: flex;
    flex-direction: row;
}

.company-button {
    margin-top: 5px;
    margin-bottom: 5px;
    width: 100%;
    border: solid 1px #ff00ea;
    background-color: #b3ffff;
}

.action-container {
    padding-bottom: 10px;
}

.inside-button-element {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
</style>